import { useCallback, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faArrowUp, faArrowDown, faFileExcel } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';

import Paginacion from '../Paginacion';
import Spinner from '../Spinner';
import Stack from '../Stack';

const Table =
({
    verifyToken,
    buscador,
    multiSelector,
    anioDesde,
    anioHasta,
    checking,
    setChecking,
    codigosProyectos,
    añosDisponibles,
    setAños,
    codigosEspecies,
    setEspecies,
    codigosPuertos,
    setPuertos,
    codigosRegiones,
    setRegiones,
    sorting,
    setSorting,
    orderbyAño,
    setOrderbyAño,
    orderbyProyecto,
    setOrderbyProyecto,
    orderbyInformacion,
    setOrderbyInformacion,
    orderbyEspecie,
    setOrderbyEspecie,
    orderbyRegion,
    setOrderbyRegion,
    orderbyPuerto,
    setOrderbyPuerto,
    orderbyRegistros,
    setOrderbyRegistros,
    orderby,
    setOrderby,
    order,
    setOrder,
    archivos,
    setArchivos,
    loading,
    setLoading,
    handlePagination,
    handleSelector,
    pages,
    setPages,
    division,
    pagination,
    setPagination,
    from,
    setFrom,
    lastPage,
    setLastPage,
    to,
    setTo,
    total,
    setTotal,
    page,
    setPage,
    status422,
    setStatus422,
    opcionesSelector,
    añosSelector,
    timestamp,
    setTimestamp
}) =>
{
    const appDebug = process.env.REACT_APP_DEBUG;
    const apiUrl = process.env.REACT_APP_API_URL;
    const repositorioUrl = process.env.REACT_APP_REPOSITORIO_URL;
    const secretKey = process.env.REACT_APP_SECRET_KEY;

    const url = 'buscador-experto-pesqueria-desarrollo';

    const handlePage = (value) =>
    {
        const result = pagination + value;

        setLoading(false);
        setPage(false);
        setPagination(result);
    }

    const handleSelectPage = (value) =>
    {
        setLoading(false);
        setPage(false);
        setPagination(value);
    }

    const handleOrderbyAño = (value, orderby, order) =>
    {
        setSorting(true);
        setOrderbyAño(value);
        setOrderbyProyecto(0);
        setOrderbyInformacion(0);
        setOrderbyEspecie(0);
        setOrderbyRegion(0);
        setOrderbyPuerto(0);
        setOrderbyRegistros(0);
        setOrderby(orderby);
        setOrder(order);
    }

    const handleOrderbyProyecto = (value, orderby, order) =>
    {
        setSorting(true);
        setOrderbyAño(0);
        setOrderbyProyecto(value);
        setOrderbyInformacion(0);
        setOrderbyEspecie(0);
        setOrderbyRegion(0);
        setOrderbyPuerto(0);
        setOrderbyRegistros(0);
        setOrderby(orderby);
        setOrder(order);
    }

    const handleOrderbyInformacion = (value, orderby, order) =>
    {
        setSorting(true);
        setOrderbyAño(0);
        setOrderbyProyecto(0);
        setOrderbyInformacion(value);
        setOrderbyEspecie(0);
        setOrderbyRegion(0);
        setOrderbyPuerto(0);
        setOrderbyRegistros(0);
        setOrderby(orderby);
        setOrder(order);
    }

    const handleOrderbyEspecie = (value, orderby, order) =>
    {
        setSorting(true);
        setOrderbyAño(0);
        setOrderbyProyecto(0);
        setOrderbyInformacion(0);
        setOrderbyEspecie(value);
        setOrderbyRegion(0);
        setOrderbyPuerto(0);
        setOrderbyRegistros(0);
        setOrderby(orderby);
        setOrder(order);
    }

    const handleOrderbyRegion = (value, orderby, order) =>
    {
        setSorting(true);
        setOrderbyAño(0);
        setOrderbyProyecto(0);
        setOrderbyInformacion(0);
        setOrderbyEspecie(0);
        setOrderbyRegion(value);
        setOrderbyPuerto(0);
        setOrderbyRegistros(0);
        setOrderby(orderby);
        setOrder(order);
    }

    const handleOrderbyPuerto = (value, orderby, order) =>
    {
        setSorting(true);
        setOrderbyAño(0);
        setOrderbyProyecto(0);
        setOrderbyInformacion(0);
        setOrderbyEspecie(0);
        setOrderbyRegion(0);
        setOrderbyPuerto(value);
        setOrderbyRegistros(0);
        setOrderby(orderby);
        setOrder(order);
    }

    const handleOrderbyRegistros = (value, orderby, order) =>
    {
        setSorting(true);
        setOrderbyAño(0);
        setOrderbyProyecto(0);
        setOrderbyInformacion(0);
        setOrderbyEspecie(0);
        setOrderbyRegion(0);
        setOrderbyPuerto(0);
        setOrderbyRegistros(value);
        setOrderby(orderby);
        setOrder(order);
    }

    const filterData = useCallback(async () =>
    {
        try
        {
            let multi = '';
            let selector = '';
            let proyectos = '';
            let años = '';
            let especies = '';
            let puertos = '';
            let regiones = '';

            multiSelector.forEach(data =>
            {
                multi += '&multi_selector[]=' + data.value;

                selector += '&multi_selector[]=' + data.value;
            });

            codigosProyectos.forEach(proyecto =>
            {
                proyectos += '&codigos_proyectos[]=' + proyecto;
            });

            añosDisponibles.forEach(año =>
            {
                años += '&anios_disponibles[]=' + año;
            });

            codigosEspecies.forEach(especie =>
            {
                multi += '&multi_selector[]=E' + especie;

                especies += '&codigos_especies[]=' + especie;
            });

            codigosPuertos.forEach(puerto =>
            {
                puertos += '&codigos_puertos[]=' + puerto;
            });

            codigosRegiones.forEach(region =>
            {
                regiones += '&codigos_regiones[]=' + region;
            });

            const url = Object.keys(buscador).length > 0 && `${buscador.value}=${buscador.label}`;

            const orderBy = orderby && order && `&orderby=${orderby}&order=${order}`;

            const responseBusqueda = Object.keys(buscador).length > 0 ?
                await axios.get(`${apiUrl}${division}/busqueda?registros=1&${url}${multi}&anio_desde=${anioDesde}&anio_hasta=${anioHasta}${proyectos}${años}${especies}${puertos}${regiones}&environment=local${orderBy}`) :
                await axios.get(`${apiUrl}${division}/busqueda?registros=1${multi}&anio_desde=${anioDesde}&anio_hasta=${anioHasta}${proyectos}${años}${especies}${puertos}${regiones}&environment=local${orderBy}`);

            const busqueda = verifyToken(responseBusqueda, appDebug, secretKey);

            if (busqueda.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setAños(busqueda.anios);
            setPuertos(busqueda.puertos);
            setRegiones(busqueda.regiones);

            const responseArchivos = Object.keys(buscador).length > 0 ?
                await axios.get(`${apiUrl}${division}/archivos?${url}&page=${pagination}${selector}&anio_desde=${anioDesde}&anio_hasta=${anioHasta}${proyectos}${años}${especies}${puertos}${regiones}&environment=local${orderBy}`) :
                await axios.get(`${apiUrl}${division}/archivos?page=${pagination}${selector}&anio_desde=${anioDesde}&anio_hasta=${anioHasta}${proyectos}${años}${especies}${puertos}${regiones}&environment=local${orderBy}`);

            const archivos = verifyToken(responseArchivos, appDebug, secretKey);

            if (archivos.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setArchivos(archivos.data);

            const from = archivos.meta.from;
            const lastPage = archivos.meta.last_page;
            const to = archivos.meta.to;
            const total = archivos.meta.total;

            setLoading(true);
            setSorting(false);
            setChecking(false);

            handlePagination(setPages, pagination, lastPage);

            setFrom(from);
            setLastPage(lastPage);
            setTo(to);
            setTotal(total);
            setStatus422(false);
            setTimestamp('');
        }
        catch (error)
        {
            const timestamp = error.response.data.timestamp;

            error.status === 422 && setStatus422(true);

            error.status === 422 && handleSelector();

            error.status === 422 && setTimestamp(timestamp);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken, handlePagination, handleSelector, buscador, multiSelector, anioDesde, anioHasta,
        codigosProyectos, añosDisponibles, codigosEspecies, codigosPuertos, codigosRegiones,
        setChecking, setSorting, orderby, order, setArchivos, setLoading, setPages, pagination, setFrom, setLastPage, setTo, setTotal, setStatus422, setTimestamp
    ]);

    const handleEffect = useCallback(async () =>
    {
        loading === false && page === false && filterData(); // este es para la paginacion
        loading === true && page === true && (checking === true || sorting === true) && filterData(); // Se carga despues de busqueda avanzada pero se necesita para los checks

        page === false && setPage(true);
    }, [filterData, checking, sorting, loading, page, setPage]);

    useEffect(() =>
    {
        handleEffect();
    }, [codigosProyectos, añosDisponibles, codigosEspecies, codigosPuertos, codigosRegiones, orderby, order, loading]);

    return (
        <div className="card" id="datos">
            <div className="card-body">

                {
                    status422 === false ?
                    (
                        <>
                            <Paginacion
                                checking={checking}
                                sorting={sorting}
                                loading={loading}
                                pages={pages}
                                pagination={pagination}
                                from={from}
                                lastPage={lastPage}
                                to={to}
                                total={total}
                                handlePage={handlePage}
                                handleSelectPage={handleSelectPage}
                            />

                            {
                                (!loading || checking || sorting) &&
                                (
                                    <Spinner />
                                )
                            }

                            <div className="rounded overflow-hidden">
                                <table id="tablaResultados" className="table table-striped text-center table-hover">
                                    <thead>
                                        <tr className="table-dark">
                                            <th>
                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-light border-0 btn-sm d-flex flex-nowrap align-items-center"
                                                        disabled={!loading || checking || sorting}
                                                    >
                                                        <span className="fw__-bold">{'Nro.'}</span>
                                                    </button>
                                                </div>
                                            </th>
                                            <th scope="col" className="text-light">

                                                {
                                                    [
                                                        {
                                                            id: 0,
                                                            value: 1,
                                                            orderby: 'ANIO',
                                                            order: 'asc',
                                                            faIcon: faArrowUp,
                                                            color: 'lightgray',
                                                        },
                                                        {
                                                            id: 1,
                                                            value: 2,
                                                            orderby: 'ANIO',
                                                            order: 'desc',
                                                            faIcon: faArrowUp,
                                                            color: 'gray',
                                                        },
                                                        {
                                                            id: 2,
                                                            value: 0,
                                                            orderby: '',
                                                            order: '',
                                                            faIcon: faArrowDown,
                                                            color: 'gray',
                                                        },
                                                    ].map((order, index) =>
                                                    (
                                                        orderbyAño === order.id &&
                                                            <div key={index} className="d-flex justify-content-center">
                                                                <button
                                                                    key={order.id}
                                                                    type="button"
                                                                    className="btn btn-outline-light border-0 btn-sm d-flex flex-nowrap align-items-center"
                                                                    onClick={() => handleOrderbyAño(order.value, order.orderby, order.order)}
                                                                    disabled={!loading || checking || sorting}
                                                                >
                                                                    <span className="fw__-bold">{'Año'}</span>
                                                                        <FontAwesomeIcon className="px-2" icon={order.faIcon} color={order.color} />
                                                                </button>
                                                            </div>
                                                    ))
                                                }

                                            </th>
                                            <th scope="col" className="text-light">

                                                {
                                                    [
                                                        {
                                                            id: 0,
                                                            value: 1,
                                                            orderby: 'DESC_PROYECTO',
                                                            order: 'asc',
                                                            faIcon: faArrowUp,
                                                            color: 'lightgray',
                                                        },
                                                        {
                                                            id: 1,
                                                            value: 2,
                                                            orderby: 'DESC_PROYECTO',
                                                            order: 'desc',
                                                            faIcon: faArrowUp,
                                                            color: 'gray',
                                                        },
                                                        {
                                                            id: 2,
                                                            value: 0,
                                                            orderby: '',
                                                            order: '',
                                                            faIcon: faArrowDown,
                                                            color: 'gray',
                                                        },
                                                    ].map((order, index) =>
                                                    (
                                                        orderbyProyecto === order.id &&
                                                            <div key={index} className="d-flex justify-content-center">
                                                                <button
                                                                    key={order.id}
                                                                    type="button"
                                                                    className="btn btn-outline-light border-0 btn-sm d-flex flex-nowrap align-items-center"
                                                                    onClick={() => handleOrderbyProyecto(order.value, order.orderby, order.order)}
                                                                    disabled={!loading || checking || sorting}
                                                                >
                                                                    <span className="fw__-bold">{'Proyecto'}</span>
                                                                        <FontAwesomeIcon className="px-2" icon={order.faIcon} color={order.color} />
                                                                </button>
                                                            </div>
                                                    ))
                                                }

                                            </th>
                                            <th scope="col" className="text-light">

                                                {
                                                    [
                                                        {
                                                            id: 0,
                                                            value: 1,
                                                            orderby: 'TIPO_INFORMACION',
                                                            order: 'asc',
                                                            faIcon: faArrowUp,
                                                            color: 'lightgray',
                                                        },
                                                        {
                                                            id: 1,
                                                            value: 2,
                                                            orderby: 'TIPO_INFORMACION',
                                                            order: 'desc',
                                                            faIcon: faArrowUp,
                                                            color: 'gray',
                                                        },
                                                        {
                                                            id: 2,
                                                            value: 0,
                                                            orderby: '',
                                                            order: '',
                                                            faIcon: faArrowDown,
                                                            color: 'gray',
                                                        },
                                                    ].map((order, index) =>
                                                    (
                                                        orderbyInformacion === order.id &&
                                                            <div key={index} className="d-flex justify-content-center">
                                                                <button
                                                                    key={order.id}
                                                                    type="button"
                                                                    className="btn btn-outline-light border-0 btn-sm d-flex flex-nowrap align-items-center"
                                                                    onClick={() => handleOrderbyInformacion(order.value, order.orderby, order.order)}
                                                                    disabled={!loading || checking || sorting}
                                                                >
                                                                    <span className="fw__-bold">{'Tipo de info'}</span>
                                                                        <FontAwesomeIcon className="px-2" icon={order.faIcon} color={order.color} />
                                                                </button>
                                                            </div>
                                                    ))
                                                }

                                            </th>
                                            <th scope="col" className="text-light">

                                                {
                                                    [
                                                        {
                                                            id: 0,
                                                            value: 1,
                                                            orderby: 'NOMBRE_ESPECIE',
                                                            order: 'asc',
                                                            faIcon: faArrowUp,
                                                            color: 'lightgray',
                                                        },
                                                        {
                                                            id: 1,
                                                            value: 2,
                                                            orderby: 'NOMBRE_ESPECIE',
                                                            order: 'desc',
                                                            faIcon: faArrowUp,
                                                            color: 'gray',
                                                        },
                                                        {
                                                            id: 2,
                                                            value: 0,
                                                            orderby: '',
                                                            order: '',
                                                            faIcon: faArrowDown,
                                                            color: 'gray',
                                                        },
                                                    ].map((order, index) =>
                                                    (
                                                        orderbyEspecie === order.id &&
                                                            <div key={index} className="d-flex justify-content-center">
                                                                <button
                                                                    key={order.id}
                                                                    type="button"
                                                                    className="btn btn-outline-light border-0 btn-sm d-flex flex-nowrap align-items-center"
                                                                    onClick={() => handleOrderbyEspecie(order.value, order.orderby, order.order)}
                                                                    disabled={!loading || checking || sorting}
                                                                >
                                                                    <span className="fw__-bold">{'Especie'}</span>
                                                                        <FontAwesomeIcon className="px-2" icon={order.faIcon} color={order.color} />
                                                                </button>
                                                            </div>
                                                    ))
                                                }

                                            </th>
                                            <th scope="col" className="text-light">

                                                {
                                                    [
                                                        {
                                                            id: 0,
                                                            value: 1,
                                                            orderby: 'NOMBRE_REG',
                                                            order: 'asc',
                                                            faIcon: faArrowUp,
                                                            color: 'lightgray',
                                                        },
                                                        {
                                                            id: 1,
                                                            value: 2,
                                                            orderby: 'NOMBRE_REG',
                                                            order: 'desc',
                                                            faIcon: faArrowUp,
                                                            color: 'gray',
                                                        },
                                                        {
                                                            id: 2,
                                                            value: 0,
                                                            orderby: '',
                                                            order: '',
                                                            faIcon: faArrowDown,
                                                            color: 'gray',
                                                        },
                                                    ].map((order, index) =>
                                                    (
                                                        orderbyRegion === order.id &&
                                                            <div key={index} className="d-flex justify-content-center">
                                                                <button
                                                                    key={order.id}
                                                                    type="button"
                                                                    className="btn btn-outline-light border-0 btn-sm d-flex flex-nowrap align-items-center"
                                                                    onClick={() => handleOrderbyRegion(order.value, order.orderby, order.order)}
                                                                    disabled={!loading || checking || sorting}
                                                                >
                                                                    <span className="fw__-bold">{'Región'}</span>
                                                                        <FontAwesomeIcon className="px-2" icon={order.faIcon} color={order.color} />
                                                                </button>
                                                            </div>
                                                    ))
                                                }

                                            </th>
                                            <th scope="col" className="text-nowrap">

                                                {
                                                    [
                                                        {
                                                            id: 0,
                                                            value: 1,
                                                            orderby: 'NOMBRE_PUERTO',
                                                            order: 'asc',
                                                            faIcon: faArrowUp,
                                                            color: 'lightgray',
                                                        },
                                                        {
                                                            id: 1,
                                                            value: 2,
                                                            orderby: 'NOMBRE_PUERTO',
                                                            order: 'desc',
                                                            faIcon: faArrowUp,
                                                            color: 'gray',
                                                        },
                                                        {
                                                            id: 2,
                                                            value: 0,
                                                            orderby: '',
                                                            order: '',
                                                            faIcon: faArrowDown,
                                                            color: 'gray',
                                                        },
                                                    ].map((order, index) =>
                                                    (
                                                        orderbyPuerto === order.id &&
                                                            <div key={index} className="d-flex justify-content-center">
                                                                <button
                                                                    key={order.id}
                                                                    type="button"
                                                                    className="btn btn-outline-light border-0 btn-sm d-flex flex-nowrap align-items-center"
                                                                    onClick={() => handleOrderbyPuerto(order.value, order.orderby, order.order)}
                                                                    disabled={!loading || checking || sorting}
                                                                >
                                                                    <span className="fw__-bold">{'Puerto'}</span>
                                                                        <FontAwesomeIcon className="px-2" icon={order.faIcon} color={order.color} />
                                                                </button>
                                                            </div>
                                                    ))
                                                }

                                            </th>
                                            <th scope="col" className="text-light">

                                                {
                                                    [
                                                        {
                                                            id: 0,
                                                            value: 1,
                                                            orderby: 'NUM_REG',
                                                            order: 'asc',
                                                            faIcon: faArrowUp,
                                                            color: 'lightgray',
                                                        },
                                                        {
                                                            id: 1,
                                                            value: 2,
                                                            orderby: 'NUM_REG',
                                                            order: 'desc',
                                                            faIcon: faArrowUp,
                                                            color: 'gray',
                                                        },
                                                        {
                                                            id: 2,
                                                            value: 0,
                                                            orderby: '',
                                                            order: '',
                                                            faIcon: faArrowDown,
                                                            color: 'gray',
                                                        },
                                                    ].map((order, index) =>
                                                    (
                                                        orderbyRegistros === order.id &&
                                                            <div key={index} className="d-flex justify-content-center">
                                                                <button
                                                                    key={order.id}
                                                                    type="button"
                                                                    className="btn btn-outline-light border-0 btn-sm d-flex flex-nowrap align-items-center"
                                                                    onClick={() => handleOrderbyRegistros(order.value, order.orderby, order.order)}
                                                                    disabled={!loading || checking || sorting}
                                                                >
                                                                    <span className="fw__-bold">{'Registros'}</span>
                                                                        <FontAwesomeIcon className="px-2" icon={order.faIcon} color={order.color} />
                                                                </button>
                                                            </div>
                                                    ))
                                                }

                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            archivos.map((archivo, index) =>
                                            (
                                                <tr className={(!loading || checking || sorting) ? 'disabled-row' : ''} key={index}>
                                                    <td>{archivo.NRO}</td>
                                                    <td>{archivo.ANIO}</td>
                                                    <td>{archivo.DESC_PROYECTO}</td>
                                                    <td>{archivo.TIPO_INFORMACION}</td>
                                                    <td>{archivo.ESPECIE.NOMBRE}

                                                        {
                                                            archivo.ESPECIE.NOMBRE_CIENTIFICO &&
                                                            (
                                                                <>
                                                                    {' ('}<i>{archivo.ESPECIE.NOMBRE_CIENTIFICO}</i>{')'}
                                                                </>
                                                            )
                                                        }

                                                    </td>
                                                    <td>{archivo.REGION.NOMBRE}</td>
                                                    <td>{archivo.PUERTO.NOMBRE}</td>
                                                    <td>{archivo.NUM_REG > 0 && archivo.NUM_REG.toLocaleString('es-CL')}</td>
                                                </tr>
                                            ))
                                        }

                                    </tbody>
                                </table>
                            </div>

                            <ul className="pagination justify-content-center">
                                <Stack
                                    checking={checking}
                                    sorting={sorting}
                                    loading={loading}
                                    pages={pages}
                                    pagination={pagination}
                                    lastPage={lastPage}
                                    handlePage={handlePage}
                                    handleSelectPage={handleSelectPage}
                                />
                            </ul>
                        </>
                    ) :
                    (
                        <>
                            {'Su argumento de búsqueda no encuentra nuevos resultados. Intente con otra combinatoria distinta a:'}
                            <div>
                                <i>{'"'}{opcionesSelector}{'"'}</i>{', entre los años: '}<i>{'"'}{añosSelector}{'"'}</i>{'.'}
                            </div>
                            <small className="text-body-secondary">{timestamp}</small>
                        </>
                    )
                }

            </div>
        </div>
    );
}

export default Table;
